import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CallReceivedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"call_received"}/>
}
